module.exports = __webpack_public_path__ + "static/9145e980.bg_new.png";